import { readable } from "svelte/store";

export const configStore = readable({
  titulka: "DEMO | Smartmap v4", // zobrazi sa v nazve tabu - <title>
  pociatocne_pozicie: {
    lat: 48.951042494068,
    lng: 18.20802414887,
    zoom: 12,
  },
  pociatocne_vrstvy: [
    {
      kod: "ortofoto-dnv",
      typ: "raster",
      kodUrl: "ortodnv,ortodnv21,hranice",
    },
    {
      kod: "cesty",
      typ: "raster",
      kodUrl: "cesty",
    },
  ],
  map: {
    maxZoom: 19.49,
    minZoom: 12,
  },
  sources: {
    maxzoom: 19.49,
    minzoom: 10,
  },
  layers: {
    maxzoom: 21,
    minzoom: 8,
  },
  /**
   * FARBY
   */
  farby: [
    { kod: "001", html_kod: "008800" }, // adresy
    { kod: "002", html_kod: "6755cc" }, // clv
    { kod: "003", html_kod: "a55063" }, // dane
    { kod: "004", html_kod: "256326" }, // eparcely
    { kod: "005", html_kod: "36493e" }, // kamery
    { kod: "006", html_kod: "13ec1a" }, // komposter
    { kod: "007", html_kod: "5ee03e" }, // kompostermeno
    { kod: "008", html_kod: "403585" }, // komunikacie
    { kod: "009", html_kod: "496240" }, // komunikaciechodnik
    { kod: "010", html_kod: "377514" }, // komunikacieine
    { kod: "011", html_kod: "973269" }, // komunikacieparkoviska
    { kod: "012", html_kod: "675822" }, // komunikacieschodisko
    { kod: "013", html_kod: "342860" }, // komunikaciezelen
    { kod: "014", html_kod: "747dbe" }, // kose
    { kod: "015", html_kod: "5b737d" }, // ku
    { kod: "016", html_kod: "7e8d18" }, // lampy
    { kod: "017", html_kod: "8c703b" }, // lavicky
    { kod: "018", html_kod: "db6d00" }, // obyvatelia
    { kod: "019", html_kod: "837f11" }, // osvetlenie
    { kod: "020", html_kod: "424242" }, // parcely
    { kod: "021", html_kod: "618acc" }, // parkoviska
    { kod: "022", html_kod: "939137" }, // psy
    { kod: "023", html_kod: "4f3d30" }, // rozhlas
    { kod: "024", html_kod: "24bafc" }, // rozhodnutia
    { kod: "025", html_kod: "25bafc" }, // rozhodnutianazov
    { kod: "026", html_kod: "157601" }, // rozhodnutiaparcely
    { kod: "027", html_kod: "2b6822" }, // rvo
    { kod: "028", html_kod: "863068" }, // semafory
    { kod: "029", html_kod: "a6428a" }, // smeti
    { kod: "030", html_kod: "b73850" }, // stojiska
    { kod: "031", html_kod: "4ea659" }, // stromy
    { kod: "032", html_kod: "000088" }, // ulice
    { kod: "033", html_kod: "6755cc" }, // vlastnici
    { kod: "034", html_kod: "31439b" }, // znacky

    // vyhladavania
    { kod: "101", html_kod: "008800" }, // Adresy, ulice, k.ú.
    { kod: "102", html_kod: "6755CC" }, // Osoba, firma
    { kod: "103", html_kod: "654380" }, // Pes, majiteľ
    { kod: "104", html_kod: "675534" }, // Parcely a L.V.
    { kod: "105", html_kod: "21BBEF" }, // Rozhodnutia
    { kod: "106", html_kod: "793028" }, // RVO, stromy, lavičky a koše, stojisko, lampy
    { kod: "107", html_kod: "185780" }, // Dopravné značenie, parkoviská, osvetlenie, rozhlas, kamery, semafóry
    { kod: "108", html_kod: "888035" }, // Doprava
    { kod: "109", html_kod: "d21717" }, // Rozkopavky

    // selecty
    { kod: "201", html_kod: "000088" }, // Ulice
    { kod: "202", html_kod: "5b737d" }, // Katastrálne úzenia

    // rozkopavky
    { kod: "301", html_kod: "8700ff" }, // rozkopavka
    { kod: "302", html_kod: "20e852" }, // v zaruke
    { kod: "303", html_kod: "ffbf00" }, // konci zaruka
    { kod: "304", html_kod: "ff0000" }, // skoncila zaruka
    { kod: "305", html_kod: "000000" }, // deleted_at
  ],
  /**
   * VYHLADAVANIE
   */
  vyhladavania: {
    typy: [
      {
        id: 1,
        nazov: "Adresy, ulice, k.ú.",
        placeholder: "Zadajte adresu, ulicu alebo k.ú.",
        typy: ["adresy", "ulice", "ku"],
        kod_ikonky: "001",
        kod_farby: "101",
      },
      {
        id: 2,
        nazov: "Osoba, firma",
        placeholder: "Zadajte meno alebo firmu",
        typy: [
          "obyvatelia",
          "psy",
          "tko",
          "vlastnici",
          "danovnik",
          "kompostery",
        ],
        kod_ikonky: "004",
        kod_farby: "102",
      },
      {
        id: 10,
        nazov: "Pes, majiteľ",
        placeholder: "Zadajte plemeno, známku alebo majiteľa",
        typy: ["majitel", "psy"],
        kod_ikonky: "005",
        kod_farby: "103",
      },
      {
        id: 4,
        nazov: "Parcely a L.V.",
        placeholder: "Zadajte číslo parcely alebo L.V.",
        typy: ["parcely", "eparcely", "lv"],
        kod_ikonky: "006",
        kod_farby: "104",
      },
      {
        id: 7,
        nazov: "Rozhodnutia",
        placeholder: "Zadajte rozhodnutie alebo meno",
        typy: ["rozhodnutia", "rnazov", "rparcely"],
        kod_ikonky: "007",
        kod_farby: "105",
      },
      {
        id: 11,
        nazov: "RVO, stromy, lavičky a koše, stojisko",
        placeholder: "RVO, stromy, lavičky a koše, stojisko",
        typy: ["rvo", "strom", "lavicky", "kose", "stojiska"],
        kod_ikonky: "075",
        kod_farby: "106",
      },
      {
        id: 12,
        nazov: "Dopr. značenie, park., osvet., rozhlas, kamery, semafóry",
        placeholder: "Zadajte číslo objektu",
        typy: [
          "znacky",
          "parkoviska",
          "osvetlenie",
          "rozhlas",
          "kamery",
          "semafory",
        ],
        kod_ikonky: "075",
        kod_farby: "107",
      },
      {
        id: 13,
        nazov: "Komunikácie, priechody, spomaľovače, smerovníky",
        placeholder: "Zadajte číslo objektu",
        typy: [
          "komunikacie",
          "komunikaciechodnik",
          "komunikacieine",
          "komunikacieparkoviska",
          "komunikacieschodisko",
          "komunikaciezelen",
          "prechody",
          "spomalovace",
          "smerovniky",
        ],
        kod_ikonky: "075",
        kod_farby: "108",
      },
      {
        id: 14,
        nazov: "Rozkopávky",
        placeholder: "Zadajte data rozkopávky",
        typy: [
          "rozkopavky_cislorz",
          "rozkopavky_ulica",
          "rozkopavky_vlastniik",
          "rozkopavky_ziadatel",
        ],
        kod_ikonky: "083",
        kod_farby: "109",
      },
      {
        id: 15,
        nazov: "Výtlky",
        placeholder: "Zadajte data výtlkov",
        typy: [
          "vytlky_cislorz",
          "vytlky_ulica",
          "vytlky_vlastniik",
          "vytlky_ziadatel",
        ],
        kod_ikonky: "082",
        kod_farby: "109",
      },
      {
        id: 16,
        nazov: "Daňovník",
        placeholder: "Zadajte meno daňovníka",
        typy: ["osoba"],
        kod_ikonky: "004",
        kod_farby: "104",
      },
    ],
  },
  /**
   * SELECTY
   */
  selecty: [
    {
      nazov: "Ulice",
      typ: "ulice",
      kod_ikonky: "008",
      kod_farby: "201",
    },
    {
      nazov: "Katastrálne úzenia",
      typ: "ku",
      kod_ikonky: "041",
      kod_farby: "202",
    },
  ],
  /**
   * TYPY
   */
  typy: [
    // systemove
    {
      id: 999,
      nazov: "Point",
      kod: ["point", "dblclick"],
      kod_farby: "006",
      kod_ikonky: "",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": "#144672",
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      id: 998,
      nazov: "Polygon",
      kod: "polygon",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "#3388ff",
            "fill-outline-color": "#3388ff",
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      id: 997,
      nazov: "LineString",
      kod: "linestring",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },

    // geo typy
    {
      nazov: "Adresy",
      kod: ["adresy"],
      kod_farby: "001",
      kod_ikonky: "001",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "E Parcely",
      kod: ["eparcely"],
      kod_farby: "004",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "%kod_farby%",
            "fill-opacity": 0.5,
          },
        },
      ],
    },
    {
      nazov: "Kamery",
      kod: ["kamery"],
      kod_farby: "005",
      kod_ikonky: "055",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Kompostér",
      kod: ["kompostery"],
      kod_farby: "006",
      kod_ikonky: "058",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Komunikácie",
      kod: ["komunikacie", "komunikacie2", "komunikacie3"],
      koddb: "komunikacie",
      kod_farby: "008",
      kod_ikonky: "057",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Chodník",
      kod: ["komunikaciechodnik", "komunikaciechodnik2", "komunikaciechodnik3"],
      koddb: "komunikaciechodnik",
      kod_farby: "009",
      kod_ikonky: "056",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Komunikácie iné",
      kod: ["komunikacieine", "komunikacieine2", "komunikacieine3"],
      koddb: "komunikacieine",
      kod_farby: "010",
      kod_ikonky: "059",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      id: 74,
      nazov: "Komunikácie parkoviská",
      kod: [
        "komunikacieparkoviska",
        "komunikacieparkoviska2",
        "komunikacieparkoviska3",
      ],
      koddb: "komunikacieparkoviska",
      kod_farby: "021",
      kod_ikonky: "061",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Schodisko",
      kod: [
        "komunikacieschodisko",
        "komunikacieschodisko2",
        "komunikacieschodisko3",
      ],
      koddb: "komunikacieschodisko",
      kod_farby: "012",
      kod_ikonky: "060",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Zeleň",
      kod: ["komunikaciezelen", "komunikaciezelen2", "komunikaciezelen3"],
      koddb: "komunikaciezelen",
      kod_farby: "013",
      kod_ikonky: "062",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Komunikácie - povrch",
      kod: ["komunikaciepovrch"],
      kod_farby: "020",
      kod_ikonky: "039",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Komunikácie - stav",
      kod: ["komunikaciestav"],
      kod_farby: "021",
      kod_ikonky: "045",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Koše",
      kod: ["kose"],
      kod_farby: "014",
      kod_ikonky: "079",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Katastrálne územia",
      kod: ["ku"],
      kod_farby: "015",
      kod_ikonky: "041",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "%kod_farby%",
            "fill-opacity": 0.5,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
          },
        },
      ],
    },
    {
      nazov: "Lampy",
      kod: ["lampy"],
      kod_farby: "016",
      kod_ikonky: "071",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Lavičky",
      kod: ["lavicky"],
      kod_farby: "017",
      kod_ikonky: "078",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "LV",
      kod: "lv",
      kod_farby: "002",
      kod_ikonky: "031",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "%kod_farby%",
            "fill-opacity": 0.5,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
          },
        },
      ],
    },
    {
      nazov: "Osvetlenie",
      kod: ["osvetlenie"],
      kod_farby: "019",
      kod_ikonky: "071",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Parcely",
      kod: ["parcely"],
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "%kod_farby%",
            "fill-opacity": 0.5,
          },
        },
      ],
    },
    {
      nazov: "Parkoviská",
      kod: ["parkoviska"],
      kod_farby: "021",
      kod_ikonky: "061",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.3,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "Rozhlas",
      kod: ["rozhlas"],
      kod_farby: "023",
      kod_ikonky: "074",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Rozhodnutia",
      kod: ["rozhodnutia", "rnazov", "rparcely"],
      kod_farby: "024",
      kod_ikonky: "007",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-opacity": 0.5,
          },
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 1,
          },
        },
      ],
    },
    {
      nazov: "RVO",
      kod: ["rvo"],
      kod_farby: "027",
      kod_ikonky: "045",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Semafory",
      kod: ["semafory"],
      kod_farby: "028",
      kod_ikonky: "076",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Stojiská",
      kod: ["stojiska"],
      kod_farby: "030",
      kod_ikonky: "045",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Stromy",
      kod: ["strom"],
      kod_farby: "031",
      kod_ikonky: "081",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Ulice",
      kod: "ulice",
      kod_farby: "032",
      kod_ikonky: "008",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
          },
        },
      ],
    },
    {
      nazov: "Značky",
      kod: ["znacky"],
      kod_farby: "034",
      kod_ikonky: "077",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Smerovníky",
      kod: ["smerovniky"],
      kod_farby: "032",
      kod_ikonky: "008",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": `%kod_farby%`,
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },

    // typy bez geo
    {
      nazov: "Obyvatelia",
      kod: "obyvatelia",
      kod_farby: "018",
      kod_ikonky: "040",
    },
    {
      nazov: "Obyvatelia <3",
      kod: ["obyvatelia3"],
      koddb: "obyvatelia3",
      kod_farby: "020",
      kod_ikonky: "066",
    },
    {
      nazov: "Obyvatelia 3-5",
      kod: ["obyvatelia35"],
      koddb: "obyvatelia35",
      kod_farby: "020",
      kod_ikonky: "067",
    },
    {
      nazov: "Obyvatelia >65",
      kod: ["obyvatelia65"],
      koddb: "obyvatelia65",
      kod_farby: "020",
      kod_ikonky: "068",
    },
    {
      nazov: "Obyvatelia 6-15",
      kod: ["obyvatelia615"],
      koddb: "obyvatelia615",
      kod_farby: "020",
      kod_ikonky: "069",
    },
    {
      nazov: "Obyvatelia 16-65",
      kod: ["obyvatelia1665"],
      koddb: "obyvatelia1665",
      kod_farby: "020",
      kod_ikonky: "070",
    },
    {
      nazov: "Psy",
      kod: "psy",
      kod_farby: "022",
      kod_ikonky: "005",
    },
    {
      nazov: "Majiteľ",
      kod: ["majitel"],
      kod_farby: "018",
      kod_ikonky: "",
    },
    {
      nazov: "Známka",
      kod: ["znamka"],
      kod_farby: "022",
      kod_ikonky: "",
    },
    {
      nazov: "Smeti",
      kod: "tko",
      kod_farby: "029",
      kod_ikonky: "026",
    },
    {
      nazov: "Vlastníci",
      kod: ["vlastnici"],
      kod_farby: "033",
      kod_ikonky: "036",
    },
    {
      nazov: "Daňovník",
      kod: ["danovnik"],
      kod_farby: "003",
      kod_ikonky: "",
    },
    {
      nazov: "Časti",
      kod: "casti",
      kod_farby: "007",
      kod_ikonky: "009",
    },
    {
      nazov: "Stavby",
      kod: ["cs", "stavby"],
      kod_farby: "020",
      kod_ikonky: "035",
    },
    {
      nazov: "Dane",
      kod: "dane",
      kod_farby: "012",
      kod_ikonky: "033",
    },
    {
      nazov: "Dane",
      kod: ["daneuo"],
      kod_farby: "012",
      kod_ikonky: "033",
    },
    {
      nazov: "Dane",
      kod: ["danevkm"],
      kod_farby: "012",
      kod_ikonky: "037",
    },
    {
      nazov: "Dokumenty",
      kod: ["dokumenty"],
      kod_farby: "020",
      kod_ikonky: "034",
    },
    {
      nazov: "EP",
      kod: ["ep"],
      kod_farby: "020",
      kod_ikonky: "038",
    },
    {
      nazov: "Info",
      kod: ["info"],
      kod_farby: "020",
      kod_ikonky: "045",
    },
    {
      nazov: "Kontajnery",
      kod: ["kontajnery"],
      kod_farby: "020",
      kod_ikonky: "063",
    },
    {
      nazov: "Parcely",
      kod: ["pa"],
      kod_farby: "020",
      kod_ikonky: "006",
    },
    {
      nazov: "VL",
      kod: ["vl"],
      kod_farby: "020",
      kod_ikonky: "039",
    },
    {
      nazov: "Info",
      kod: ["vyrobca"],
      kod_farby: "020",
      kod_ikonky: "045",
    },

    // vektorove
    {
      nazov: "Parcely",
      kod: ["vparcely"],
      koddb: "vektor",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "Parcely E",
      kod: ["veparcely"],
      koddb: "vektor",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "green",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Metropolis Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "green",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "Adresy",
      kod: ["vadresy"],
      koddb: "vektor",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Metropolis Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "green",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK casti",
      kod: ["vskcasti"],
      koddb: "casti",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "green",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "green",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 10,
        },
      ],
    },
    {
      nazov: "SK GN",
      kod: ["vskgn"],
      koddb: "gn",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK kraj",
      kod: ["vskkraj"],
      koddb: "kraj",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 9,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK ku",
      kod: ["vskku"],
      koddb: "ku",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK obec",
      kod: ["vskobec"],
      koddb: "obec",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK okres",
      kod: ["vskokres"],
      koddb: "okres",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 9,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "SK sr",
      kod: ["vsksr"],
      koddb: "sr",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "%kod_farby%",
          },
          minzoom: 9,
          filter: ["==", "$type", "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "%kod_farby%",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
        },
      ],
    },
    {
      nazov: "Budovy",
      kod: ["vbudovy"],
      koddb: "budovy",
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "hsl(35, 8%, 85%)",
            "fill-outline-color": {
              base: 1,
              stops: [
                [13, "hsla(35, 6%, 79%, 0.32)"],
                [14, "hsl(35, 6%, 79%)"],
              ],
            },
          },
          minzoom: 13,
          maxzoom: 15,
        },
        {
          typ_vrstvy: "fill-extrusion",
          paint: {
            "fill-extrusion-color": "hsl(35, 8%, 85%)",
            "fill-extrusion-height": {
              property: "heightaboveground",
              type: "identity",
            },
            "fill-extrusion-opacity": 0.8,
          },
          minzoom: 15,
        },
      ],
    },
    {
      nazov: "Rozkopávky",
      kod: "rozkopavky",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "fill-outline-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "fill-opacity": 0.2,
          },
          filter: ["==", ["geometry-type"], "Polygon"],
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "line-width": 4,
            "line-opacity": 0.7,
          },
          filter: ["==", ["geometry-type"], "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
          filter: ["==", ["geometry-type"], "Point"],
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "line-width": 4,
          },
          filter: ["==", ["geometry-type"], "LineString"],
        },
      ],
    },
    {
      nazov: "Výtlky",
      kod: "vytlky",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "fill-outline-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "fill-opacity": 0.2,
          },
          filter: ["==", ["geometry-type"], "Polygon"],
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "line-width": 4,
            "line-opacity": 0.7,
          },
          filter: ["==", ["geometry-type"], "Polygon"],
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
          filter: ["==", ["geometry-type"], "Point"],
        },
        {
          typ_vrstvy: "line",
          paint: {
            "line-color": [
              "case",
              [
                "all",
                ["has", "v_zaruke"],
                ["boolean", ["get", "v_zaruke"], true],
              ],
              "#20e852",
              [
                "all",
                ["has", "konci_zaruka"],
                ["boolean", ["get", "konci_zaruka"], true],
              ],
              "#ffbf00",
              [
                "all",
                ["has", "skoncila_zaruka"],
                ["boolean", ["get", "skoncila_zaruka"], true],
              ],
              "#ff0000",
              [
                "all",
                ["has", "deleted_at"],
                ["!=", ["get", "deleted_at"], null],
              ],
              "#464646",
              "#8700ff",
            ],
            "line-width": 4,
          },
          filter: ["==", ["geometry-type"], "LineString"],
        },
      ],
    },
    {
      nazov: "Priechody pre chodcov",
      kod: ["prechody"],
      kod_farby: "020",
      kod_ikonky: "039",
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": "#144672",
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Spomaľovače",
      kod: ["spomalovace"],
      kod_farby: "020",
      kod_ikonky: "045",
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": "#144672",
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Danovnik",
      kod: ["osoba"],
      kod_farby: "005",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "%kod_farby%",
            "fill-opacity": 0.5,
          },
        },
      ],
    },
  ],
});
